import { Spinner, Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import NoUploads from '../components/NoUploads'
import { useSessionContext } from '../contexts/SessionContext'
import { useUserAgamiList } from '../hooks/useUserAgamiList'
import AgamiPreviewCard from './AgamiPreviewCard'

const AgamiCardGrid = () => {
  const { t } = useTranslation()
  const { user } = useSessionContext()
  const { isLoading, agamiList, refetch } = useUserAgamiList({ getAudioUrls: true })
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {isLoading && <Spinner className="h-6 w-6 mt-4" />}

      {!isLoading && (!agamiList || agamiList?.length === 0) && (
        <div className="w-full col-span-3 text-center dark:text-white">
          <NoUploads>
            <Typography className="dark:text-gray-200">
              {t('dashboard.noUploadsYet')}{' '}
              <Link to="/upload" className="underline">
                {t('dashboard.startHere')}
              </Link>{' '}
              {t('common.or')}{' '}
              <Link to="/faq#spot-faq" className="underline">
                {t('dashboard.readMore')}
              </Link>
              .
            </Typography>
          </NoUploads>
        </div>
      )}

      {!isLoading &&
        agamiList?.map((spot) => (
          <div key={spot.id} className="flex-1 mb-4 basis-1/4">
            <AgamiPreviewCard userId={user?.id || null} spot={spot} refetchAgamiList={refetch} />
          </div>
        ))}
    </div>
  )
}

export default AgamiCardGrid
